































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Field, Popup, Picker } from "vant";

@Component({
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  }
})
export default class CustomSelect extends Vue {
  showPicker = false;
  oValue = "";

  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  private disabled: any;

  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  private vertical: any;

  @Prop({
    type: String,
    default() {
      return "";
    }
  })

  private labelWidth: any;

  @Prop({
    type: String,
    default() {
      return "150px";
    }
  })
  private label: any;

  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  private required: any;

  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  private columns: any;

  @Prop({
    type: [String, Number],
    default() {
      return "";
    }
  })
  private value: any;

  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  private labelStyle: any;

  @Prop({
    type: String,
    default() {
      return "right";
    }
  })
  private inputAlign: any;


  @Watch("value", { immediate: true })
  watchValue(val: any) {
      const res = this.columns.find((item: { value: any; }) => {
        return item.value == val;
      });
      this.oValue = (res && res.text) || "";
  }

  get oLabel() {
    return this.vertical ? "" : this.label;
  }

  get defaultIndex(){
	  let _index = this.columns.findIndex(item => {
		  return item.value == this.value;
	  });
	  return _index;
  }

  handleConfirm(item: { text: string; value: any; }) {
    if (this.oValue !== item.text) {
      this.oValue = item.text;
      this.$emit("change", item);
    }

    this.$emit("input", item.value);
    this.showPicker = false;
  }
}
